import { Outlet, useLocation } from 'react-router-dom';
import { AdminNav } from '../../components/Admin/AdminNav';
import { Auth0ProviderWithNavigate } from '../../auth0-provider';

/**
 * Layout component for admin pages, includes admin navigation
 */
export const AdminLayout = () => {
  const location = useLocation();
  const isAdminV2 = location.pathname.startsWith('/admin-v2');
  const className = isAdminV2 ? '' : 'p-4';

  return (
    <Auth0ProviderWithNavigate>
      {!isAdminV2 && <AdminNav />}
      <main className={className}>
        <Outlet />
      </main>
    </Auth0ProviderWithNavigate>
  );
};
